/* eslint-disable react/style-prop-object */
import { FC } from 'react'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import Button from '@app/components/Button'
import ReactMarkdown from 'react-markdown'
import useCampaignHref from '@app/hooks/useCampaignHref'
import S from './Valuation.styles'

interface ValuationProps {
  value: number
}

const Valuation: FC<ValuationProps> = ({ value }) => {
  const { formatMessage, formatNumber } = useIntl()
  const { href: shippingHref } = useCampaignHref({ requestPath: 'quiz/shipping' })

  return (
    <S.ValuationBody>
      <h3>
        <FormattedMessage
          id="quiz_traded_product_page.content.offer_dialog.title"
          values={{
            value: <FormattedNumber value={value} style="currency" currency="EUR" maximumFractionDigits={0} />,
          }}
        />
      </h3>
      <ReactMarkdown>
        {
          formatMessage(
            { id: 'quiz_traded_product_page.content.offer_dialog.description' },
            { value: formatNumber(value, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }) }
          ) as string
        }
      </ReactMarkdown>
      <Button to={shippingHref}>
        <FormattedMessage id="quiz_traded_product_page.content.offer_dialog.button_text" />
      </Button>
    </S.ValuationBody>
  )
}

export default Valuation
